import { render, staticRenderFns } from "./DataUpdater.vue?vue&type=template&id=56edcf61&scoped=true"
import script from "./DataUpdater.vue?vue&type=script&lang=js"
export * from "./DataUpdater.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "56edcf61",
  null
  
)

export default component.exports